export default {
    create(props) {
        return Object.assign({
            order: 0,
            name: '',
            completed: false
        }, props);
    }
};
